export const newOrderNotificationAction = (payload) => {
    return {
        type: "NEWORDER",
        payload
    }
}

export const resetNotification = () => {
    return {
        type: "RESETNOTIFICATION",
        payload: {
            customer_name: ''
        }
    }
}